import React, { useState } from 'react';
import { Brikk } from 'components/Brikk';
import { useFloorPlan } from 'services/living-info/floor-plan';
import { useLivingInfo } from 'services/living-info/living-info/hook';
import { MyHomeIcon } from 'assets/icons/brikks/MyHomeIcon';
import { BrikkInfoModal } from 'components/modals/BrikkInfoModal';
import { Draggable } from 'components/drag-and-drop';
import { InfoButton } from 'components/form-elements/buttons/InfoButton';
import { SeeMoreButton } from 'components/form-elements/buttons/SeeMoreButton';
import { BrikkModal } from 'components/modals/BrikkModal';
import { LivingInfoModal } from './components/LivingInfoModal';
import { LivingInfoPreview } from './components/LivingInfoPreview';

export const MyHome = ({ position, status, code, name }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);

  useFloorPlan();

  const { loading } = useLivingInfo();

  const handleInfoModal = (e) => {
    e.stopPropagation();
    setIsInfoModalOpen(!isInfoModalOpen);
  };

  const handleOpenModal = (e) => {
    e.stopPropagation();
    setIsModalOpen(true);
  };

  return (
    <>
      <Draggable position={position}>
        <Brikk
          isLoading={loading}
          brikkKey={code}
          name={name}
          status={status}
        >
          <Brikk.Header
            icon={<MyHomeIcon />}
            heading="myHome"
            status={status}
            brikkKey={code}
          />

          <Brikk.Content>
            <LivingInfoPreview />
          </Brikk.Content>

          <Brikk.Button>
            <SeeMoreButton
              onClick={handleOpenModal}
              brikkNameIntl="myHome"
            />

            <InfoButton
              showModal={isInfoModalOpen}
              onClick={handleInfoModal}
            />
          </Brikk.Button>
        </Brikk>
      </Draggable>

      <BrikkInfoModal
        title="My home info"
        // info={info}
        showModal={isInfoModalOpen}
        onClick={() => setIsInfoModalOpen(!isInfoModalOpen)}
      />

      <BrikkModal
        twoGrid
        isOpen={isModalOpen}
        heading="myHome"
        onClose={() => setIsModalOpen(false)}
      >
        <LivingInfoModal />
      </BrikkModal>
    </>
  );
};
